import { render, staticRenderFns } from "./sessionsTable.vue?vue&type=template&id=0dfd549d&"
import script from "./sessionsTable.vue?vue&type=script&lang=js&"
export * from "./sessionsTable.vue?vue&type=script&lang=js&"
import style0 from "./sessionsTable.vue?vue&type=style&index=0&id=0dfd549d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports